<template>
  <img :src="imgSrc" :srcset="allowSrcset && srcset" @error="handleImgLoadError" />
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MImage',
  props: {
    defaultImg: {
      type: String,
      required: false,
    },
    trip: {
      type: Object,
      required: true,
    },
    srcset: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      imgSrc: this.defaultImg || '',
      triedToLoadOriginal: false,
      allowSrcset: true,
    }
  },
  computed: {
    ...mapState(['defaultImgUrl']),
  },
  methods: {
    handleImgLoadError() {
      if (!this.triedToLoadOriginal && this.trip.photo) {
        this.imgSrc = this.trip.photo
        this.triedToLoadOriginal = true
        this.allowSrcset = false
      } else {
        this.imgSrc = this.defaultImgUrl
      }
    },
  },
}
</script>
